const checkOverflow = () => {
    const containers = document.querySelectorAll('.features-table-wrapper');

    containers.forEach(container => {
        const tableWrapper = container.querySelector('.features-table');
        const table = container.querySelector('.features-table');
        if (table.scrollHeight > table.clientHeight || table.scrollWidth > table.clientWidth) {
            tableWrapper.classList.add('overflows');
        } else {
            tableWrapper.classList.remove('overflows');
        }
    });
}

export default checkOverflow;